import { combineReducers } from 'redux';
import authReducer from 'store/reducers/auth/slice';

const rootReducer = combineReducers({
  auth: authReducer,
});

export default rootReducer;
